/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import AlarmRoutes from './alarms.routes';
import AlarmsController from './alarms.controller';

export default angular.module('tektelic.alarms', [])
    .config(AlarmRoutes)
    .controller('AlarmsController', AlarmsController)
    .name;



// WEBPACK FOOTER //
// ./src/app/alarm/index.js